import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Portrait from '../Portrait'
import BlockTitle from '../BlockTitle'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(144)};
  }
`
export const _BlockTitle = styled(BlockTitle)`
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
`
export const _Portrait = styled(Portrait)`
  & img {
    object-fit: cover;
  }
`
export const Grid = styled.ul`
  --portraitgrid-aspect-ratio__item--small: 1;
  --portraitgrid-aspect-ratio__item--big: 359 / 500;
  list-style: none;
  display: flex;
  flex-flow: column;
  & li {
    width: calc(100% - ${pxToRem(16)});
  }
  & li:nth-child(6n + 1) ${_Portrait} {
    aspect-ratio: var(--portraitgrid-aspect-ratio__item--small);
  }
  & li:nth-child(6n + 2) ${_Portrait} {
    aspect-ratio: var(--portraitgrid-aspect-ratio__item--big);
  }
  & li:nth-child(6n + 3) {
    margin-inline: auto;
  }
  & li:nth-child(6n + 3) ${_Portrait} {
    aspect-ratio: var(--portraitgrid-aspect-ratio__item--small);
  }
  & li:nth-child(6n + 4) ${_Portrait} {
    aspect-ratio: var(--portraitgrid-aspect-ratio__item--big);
  }
  & li:nth-child(6n + 5) ${_Portrait} {
    aspect-ratio: var(--portraitgrid-aspect-ratio__item--big);
  }
  & li:nth-child(6n + 6) {
    margin-inline: auto;
  }
  & li:nth-child(6n + 6) ${_Portrait} {
    aspect-ratio: var(--portraitgrid-aspect-ratio__item--small);
  }
  @media ${mq(sizes.tablet)} {
    flex-flow: row wrap;
    width: 100%;
    max-width: calc(100% - ${pxToRem(16)} * 2);
    margin-inline: auto;
    // reset
    // eslint-disable-next-line prettier/prettier
    & li:nth-child(6n + 1) ${_Portrait},
    // eslint-disable-next-line prettier/prettier
    & li:nth-child(6n + 2) ${_Portrait},
    // eslint-disable-next-line prettier/prettier
    & li:nth-child(6n + 3),
    // eslint-disable-next-line prettier/prettier
    & li:nth-child(6n + 3) ${_Portrait},
    // eslint-disable-next-line prettier/prettier
    & li:nth-child(6n + 4) ${_Portrait},
    // eslint-disable-next-line prettier/prettier
    & li:nth-child(6n + 5) ${_Portrait},
    // eslint-disable-next-line prettier/prettier
    & li:nth-child(6n + 6),
    // eslint-disable-next-line prettier/prettier
    & li:nth-child(6n + 6) ${_Portrait} {
      aspect-ratio: unset;
      margin-inline: unset;
    }
    // set
    & li {
      flex: 0 0 calc(50% - ${pxToRem(16)} / 2);
      width: auto;
    }
    & li:nth-child(4n + 3) {
      margin-inline-start: ${pxToRem(16)};
    }
  }
  @media ${mq(sizes.desktop)} {
    --portraitgrid-aspect-ratio__item--small: 1;
    --portraitgrid-aspect-ratio__item--medium: 572 / 480;
    --portraitgrid-aspect-ratio__item--landscape: 688 / 450;
    --portraitgrid-aspect-ratio__item--big: 688 / 600;
    --portraitgrid-width__item--small: 25%;
    --portraitgrid-width__item--medium: calc(572 / 1376 * 100%);
    --portraitgrid-width__item--big: 50%;
    max-width: calc(100% - ${pxToRem(32)} * 2);
    & li:nth-child(4n + 3) {
      margin-inline-start: unset;
    }
    & li:nth-child(8n + 1) {
      flex: 0 0 var(--portraitgrid-width__item--small);
    }
    & li:nth-child(8n + 1) ${_Portrait} {
      aspect-ratio: var(--portraitgrid-aspect-ratio__item--small);
    }
    & li:nth-child(8n + 2) {
      flex: 0 0 var(--portraitgrid-width__item--medium);
    }
    & li:nth-child(8n + 2) ${_Portrait} {
      aspect-ratio: var(--portraitgrid-aspect-ratio__item--medium);
    }
    & li:nth-child(8n + 3) {
      flex: 0 0 var(--portraitgrid-width__item--big);
    }
    & li:nth-child(8n + 3) ${_Portrait} {
      aspect-ratio: var(--portraitgrid-aspect-ratio__item--landscape);
    }
    & li:nth-child(8n + 4) {
      flex: 0 0 var(--portraitgrid-width__item--big);
    }
    & li:nth-child(8n + 4) ${_Portrait} {
      aspect-ratio: var(--portraitgrid-aspect-ratio__item--big);
    }
    & li:nth-child(8n + 5) {
      flex: 0 0 var(--portraitgrid-width__item--medium);
      margin-inline-start: auto;
      & li:nth-child(8n + 5) ${_Portrait} {
        aspect-ratio: var(--portraitgrid-aspect-ratio__item--medium);
      }
    }
    & li:nth-child(8n + 6) {
      flex: 0 0 var(--portraitgrid-width__item--small);
    }
    & li:nth-child(8n + 6) ${_Portrait} {
      aspect-ratio: var(--portraitgrid-aspect-ratio__item--small);
    }
    & li:nth-child(8n + 7) {
      flex: 0 0 var(--portraitgrid-width__item--big);
    }
    & li:nth-child(8n + 7) ${_Portrait} {
      aspect-ratio: var(--portraitgrid-aspect-ratio__item--big);
    }
    & li:nth-child(8n + 8) {
      flex: 0 0 var(--portraitgrid-width__item--big);
    }
    & li:nth-child(8n + 8) ${_Portrait} {
      aspect-ratio: var(--portraitgrid-aspect-ratio__item--landscape);
    }
  }
`
